import React, { useCallback, useState } from 'react';
import dateFormat from 'dateformat';
import { Modal } from 'react-bootstrap';

import {
  DownLoadIcon,
  MailIcon,
} from 'components/Granel/TechnicalDocumentation/FileItem/styles';

import { getDownloadContracts } from 'services/contractsServices';
import Loading from 'components/layout/loading';
import ModalSendMailContract from '../ModalSendMailContract';
import { ContractData } from '../Contract/types';

import {
  Container,
  ContractNumberText,
  Controllers,
  DataLabel,
  DataText,
  DataWrap,
  TypeDescription,
  WrapItems,
} from './styles';

interface ItemBoxProps {
  item: ContractData;
  siteId: string | number;
}

const ItemBox: React.FC<ItemBoxProps> = ({ item, siteId }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [emailSuccess, setEmailSuccess] = useState<boolean>(false);
  const [showModalEmail, setShowModalEmail] = useState<boolean>(false);

  const beginDate = `${item.beginDate}T12:00:00`;
  const newBeginDate = new Date(beginDate);
  const endDate = `${item.endDate}T12:00:00`;
  const newEndDate = new Date(endDate);

  const handleClickDownloadItem = useCallback(
    async (method: string, emailInfo = '') => {
      const { attachmentId } = item;
      const contactIdSf = localStorage.getItem(
        '@UltragazEmpresarial:contactIdSf'
      );
      const deliveryMethod = method;

      setLoading(true);
      await getDownloadContracts({
        contactIdSf,
        siteId,
        deliveryMethod,
        contractNumber: item.contractNumber,
        documentName: item.contractType.toLowerCase(),
        attachmentId,
        beginDate: item.beginDate,
        endDate: item.endDate,
        email: emailInfo || '',
      });
      setLoading(false);
    },
    [siteId, item, setLoading]
  );

  const sendMail = useCallback(async () => {
    await handleClickDownloadItem('EMAIL', email);
    setEmailSuccess(true);
  }, [email, handleClickDownloadItem]);

  return (
    <Container>
      {loading && <Loading />}
      <WrapItems>
        <TypeDescription>{item.contractType}</TypeDescription>
        <ContractNumberText>{item.contractNumber}</ContractNumberText>
        <DataWrap>
          <DataLabel>
            {item.contractType === 'Contrato'
              ? 'Início do contrato:'
              : 'Início de vigência:'}
          </DataLabel>
          <DataText>{dateFormat(newBeginDate, 'dd/mm/yyyy')}</DataText>
        </DataWrap>
        <DataWrap>
          <DataLabel>
            {item.contractType === 'Contrato'
              ? 'Término do contrato:'
              : 'Término de vigência'}
          </DataLabel>
          <DataText>{dateFormat(newEndDate, 'dd/mm/yyyy')}</DataText>
        </DataWrap>
      </WrapItems>
      <Controllers>
        <DownLoadIcon
          style={{
            marginLeft: '8px',
          }}
          size={22}
          color="#0b29fb"
          onClick={() => handleClickDownloadItem('DOWNLOAD')}
        />
        <MailIcon
          style={{
            marginLeft: '8px',
          }}
          size={22}
          color="#0b29fb"
          onClick={() => setShowModalEmail(true)}
        />
      </Controllers>
      <Modal
        show={showModalEmail}
        onHide={() => setShowModalEmail(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalSendMailContract
          email={email}
          setEmail={setEmail}
          close={() => setShowModalEmail(false)}
          sendMail={sendMail}
          isLoading={loading}
          setMailSuccess={setEmailSuccess}
          mailSuccess={emailSuccess}
        />
      </Modal>
    </Container>
  );
};

export default ItemBox;
